import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { usePublicOfferAssetContext } from '../../../../../contexts/products/PublicOffer';
import { LateralBar } from '../../../components/LateralBar';
import { ListLoadingItemTablet } from '../ListLoadingItem/tablet';

import { PublicOfferItemTypes } from '.';

export const PublicOfferItemTablet: React.FC<PublicOfferItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePublicOfferAssetContext();
  const { infoGetter, selectedTab } = useGlobalAssetContext();

  const { Button, isSelected, forceLoading } = infoGetter('publicOffers', offer, 'offerId');

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const topInfos = [
    {
      label: 'Tipo Oferta',
      value: (
        <HStack space={Spacing['inline.quarck']} alignItems="center">
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
          <UI.Text color="neutral.dark">{offer.offerType}</UI.Text>
        </HStack>
      ),
      maxW: '19%',
    },
    {
      label: 'Empresa',
      value: <UI.Text color="neutral.dark">{offer.companyName}</UI.Text>,
      maxW: '19%',
    },
    {
      label: 'Nome',
      value: <UI.Text color="neutral.dark">{offer.offerName}</UI.Text>,
      maxW: '19%',
    },
    {
      label: 'Cód. Isin',
      value: <UI.Text color="neutral.dark">{offer.isinCode}</UI.Text>,
      maxW: '19%',
    },
    {
      label: 'Alteração',
      value: <UI.Text color="neutral.dark">{offer.alterationDateFormatted}</UI.Text>,
      maxW: '19%',
    },
  ];

  const bottomInfos = [
    {
      label: 'Negociação',
      value: <UI.Text color="neutral.dark">{offer.negotiationDateFormatted}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Liquidação',
      value: <UI.Text color="neutral.dark">{offer.liquidityDateFormatted}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Limitador',
      value: <UI.Text color="neutral.dark">{offer.limiter}</UI.Text>,
      maxW: '24%',
    },
  ];

  if (forceLoading) {
    return <ListLoadingItemTablet />;
  }

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px={Spacing['inline.xxxs']}
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          {topInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
          <Stack alignSelf="flex-end" maxW={'24%'}>
            <Button
              id={selectedTab.typeGetterId}
              offer={offer}
              productContextConstant={selectedTab}
            />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
